import { render, staticRenderFns } from "./ConfigTeachTable.vue?vue&type=template&id=76eaf0a4&scoped=true"
import script from "./ConfigTeachTable.vue?vue&type=script&lang=js"
export * from "./ConfigTeachTable.vue?vue&type=script&lang=js"
import style0 from "./ConfigTeachTable.vue?vue&type=style&index=0&id=76eaf0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eaf0a4",
  null
  
)

export default component.exports